import {
  LoaderFunctionArgs,
  redirect,
  json,
  type MetaFunction,
} from "@remix-run/node";
import { getUserSession } from "~/.server/session";
import api from "~/.server/api";

export const meta: MetaFunction = () => {
  return [{ title: "FlirtyBum" }];
};

export async function loader({ request }: LoaderFunctionArgs) {
  let user = null;
  try {
    user = await getUserSession(request);
    if (user) {
      return redirect("/landing-pub");
    }
  } catch (error) {
    // Session check failed, proceed to render the lander page
  }

  // Profiles are now hardcoded in NewMembersSection, so no need to fetch here.
  return json({});
}

import React from "react";
import { ArrowRightIcon } from "lucide-react";
// Removed useLoaderData as profiles are no longer passed from loader
import AuthFooter from "~/components/auth-footer";
import NewMembersSection from "~/components/lander-sections/NewMembersSection";
import AboutFlirtyBumSection from "~/components/lander-sections/AboutFlirtyBumSection";
import HowItWorksSection from "~/components/lander-sections/HowItWorksSection";

// Import the InnerView-wrapped policy components
import TermsAndConditionsInnerView from "~/routes/_app.settings/components/innerview/terms-and-conditions";
import PrivacyPolicyInnerView from "~/routes/_app.settings/components/innerview/privacy-statement";
import ContactInnerView from "~/routes/_app.settings/components/innerview/contact";
import AboutUsInnerView from "~/routes/_app.settings/components/innerview/about-us";

export default function IndexPage() {
  // Removed const { profiles } = useLoaderData<typeof loader>(); as profiles are no longer passed

  return (
    <div className="relative flex flex-col min-h-screen w-full text-white">
      {/* Fixed Background image with overlay and decorative elements */}
      <div className="fixed inset-0 z-0">
        <div
          className="absolute inset-0 w-full h-full bg-cover bg-center"
          style={{
            backgroundImage: 'url("/FBLANDERbackground.png")',
          }}
        />
        <div className="absolute inset-0 bg-[#c56c7f]/60" />{" "}
        {/* Pink overlay */}
        {/* Decorative chat bubbles - moved here */}
        <div className="absolute top-10 left-10 w-24 h-24 bg-white/5 rounded-full backdrop-blur-sm z-1"></div>
        <div className="absolute bottom-20 right-10 w-32 h-32 bg-white/5 rounded-full backdrop-blur-sm z-1"></div>
        <div className="absolute top-1/3 right-1/4 w-16 h-16 bg-white/5 rounded-full backdrop-blur-sm z-1"></div>
        <div className="absolute bottom-1/3 left-1/4 w-20 h-20 bg-white/5 rounded-full backdrop-blur-sm z-1"></div>
        {/* Background elements (white circles) - moved here, now relative to this z-0 container */}
        <div className="absolute bottom-0 left-0 w-full h-32 flex justify-around items-end opacity-20 z-1">
          <div className="w-16 h-16 bg-white rounded-full mb-2"></div>
          <div className="w-12 h-12 bg-white rounded-full mb-8"></div>
          <div className="w-20 h-20 bg-white rounded-full mb-4"></div>
          <div className="w-14 h-14 bg-white rounded-full mb-10"></div>
          <div className="w-16 h-16 bg-white rounded-full mb-6"></div>
        </div>
      </div>
      {/* Main scrollable content area - now on top of fixed background */}
      <div className="relative z-10 flex-grow overflow-y-auto overscroll-none">
        {" "}
        {/* Removed pb-20 */}
        {/* Initial "Enter" section */}
        <div className="text-center px-6 max-w-3xl pt-48 mx-auto flex flex-col justify-center items-center min-h-[calc(100vh-100px)] mb-10">
          {" "}
          {/* Removed min-h-[calc(100vh-100px)] */}
          {/* Logo */}
          <div className="flex items-center justify-center gap-2 mb-6">
            <img
              src="/flirtybumblack.svg"
              alt="FlirtyBum Logo"
              className="h-24"
            />
          </div>
          <p className="text-xl md:text-2xl mb-8 text-white/90">
            Connect, chat, and flirt with interesting people around you
          </p>
          <button
            onClick={() => (window.location.href = "/auth/login")}
            className="group flex items-center gap-2 bg-[#C0123E] hover:bg-[#a81037] px-8 py-4 rounded-lg text-xl font-bold transition-all duration-300"
          >
            Enter
            <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
        {/* New Sections - will now be part of the scrollable content, transparent backgrounds */}
        <NewMembersSection /> {/* No longer passing profiles prop */}
        <AboutFlirtyBumSection />
        <HowItWorksSection />
      </div>
      {/* Spacer div to ensure footer is at the very bottom of scrollable content */}
      <div className="h-20"></div> {/* Added spacer div */}
      <AuthFooter className="w-full bg-black bg-opacity-50 text-white z-10 absolute bottom-0" />{" "}
      {/* Moved inside, removed fixed positioning */}
      {/* Render InnerView-wrapped policy components */}
      <TermsAndConditionsInnerView profile={undefined} />
      <PrivacyPolicyInnerView profile={undefined} />
      <ContactInnerView profile={undefined} />
      <AboutUsInnerView profile={undefined} />
    </div>
  );
}
